import {Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild} from '@angular/core';
import {FileConversionService} from '../../global-services/file-conversion.service';

@Component({
    selector: 'app-image-cropper-v2',
    templateUrl: './image-cropper-v2.component.html',
    styleUrls: ['./image-cropper-v2.component.scss']
})
export class ImageCropperV2Component implements OnChanges {
    @Input() imageFile: File;
    @Output() imageUpdated = new EventEmitter<File>();
    @Output() cropperClose = new EventEmitter<void>();

    @ViewChild('cropperImage', { static: false }) cropperImage: ElementRef;
    private _cropper: Cropper;

    imageUrl: string;

    constructor(private readonly fileConversionService: FileConversionService) {
    }


    ngOnChanges() {
        if (this.imageFile && this.imageFile instanceof File) {
            if (this.imageFile.type === 'image/heic' || this.imageFile.name.endsWith('.heic')) {
                this.fileConversionService.heicToJpeg(this.imageFile).subscribe({
                    next: (convertedFile) => {
                        if (convertedFile) {
                            this.createImageUrl(convertedFile);
                            this.imageFile = convertedFile;
                        }
                    },
                    error: (err) => {
                        console.error('Error converting HEIC file:', err);
                    }
                });
            } else {
                this.createImageUrl(this.imageFile);
            }
        } else {
            console.error('Invalid image file provided.');
        }
    }

    createImageUrl(file: File) {
        try {
            this.imageUrl = URL.createObjectURL(file);
        } catch (error) {
            console.error('Error creating object URL:', error);
        }
    }

    cropperLoad() {
        if (this.cropperImage && this.cropperImage?.nativeElement) {
            setTimeout(() => {
                this._cropper = new Cropper(this.cropperImage.nativeElement, {
                    aspectRatio: 1,
                    viewMode: 1,
                });
            }, 100);
        }
    }

    saveCroppedImage() {
        if (!this._cropper) {
            return;
        }
        this._cropper.enable();
        this._cropper.getCroppedCanvas().toBlob(blob => {
            if (blob) {
                const croppedFile = new File([blob], this.imageFile.name, { type: this.imageFile.type });
                this.imageUpdated.emit(croppedFile);
            }
        }, this.imageFile.type, 0.9);
    }

    cancelCropper() {
        this.cropperClose.emit();
    }
}
